import React from 'react';
import { string, node } from 'prop-types';
import setClass from '../../common/set-class';
import { Icon } from '../../atoms';
function ModalHeader({ text, icon, className, children }) {
    return (React.createElement("div", { className: setClass(['b-h2', 'b-modal__header_wrapper', className]) },
        icon && React.createElement(Icon, { name: icon, className: "b-modal__header_icon" }),
        text,
        children));
}
ModalHeader.propTypes = {
    text: string,
    icon: string,
    className: string,
    children: node,
};
ModalHeader.defaultProps = {
    text: null,
    icon: null,
    className: null,
    children: null,
};
function ModalContent({ className, children }) {
    return (React.createElement("div", { className: setClass(['b-txt', 'b-modal__content-wrapper', className]) }, children));
}
const PROP_TYPES = {
    className: string,
    children: node.isRequired,
};
ModalContent.propTypes = { ...PROP_TYPES };
ModalContent.defaultProps = {
    className: null,
};
function ModalFooter({ className, children }) {
    return (React.createElement("div", { className: setClass(['b-modal__footer-wrapper', className]) }, children));
}
ModalFooter.propTypes = { ...PROP_TYPES };
ModalFooter.defaultProps = {
    className: string,
};
function Delimiter() {
    return React.createElement("div", { className: "b-modal__delimiter" });
}
export { ModalHeader, ModalContent, ModalFooter, Delimiter };
